interface props {
  color?: string;
}

export default function PotionIcon({ color = 'white' }: props) {
  return (

    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99997 3.99994L14 3.99995V6.56771C14 6.82597 14.1709 7.0552 14.4125 7.14656C22.9367 10.3708 20.9066 22 15 22H8.99998C3.09343 22 1.06325 10.3708 9.58751 7.14656C9.82907 7.05519 9.99997 6.82596 9.99997 6.5677V3.99994Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 10H18" stroke={color} stroke-width="1.5" />
      <path d="M9 2H15" stroke={color} stroke-width="1.5" stroke-linecap="round" />
      <path d="M11.6667 13L10 16H14L12.3333 19" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}